import React from "react"
import PropTypes from "prop-types"
import Widget from "../layout/widget/Widget"
import ColumnChart from "../charts/generic/ColumnChart"
import TotalEmployeesSummaryShape from "../../state/shapes/TotalEmployeesSummaryShape"

function TotalEmployeesBar({ appliedFilters, data, exportEndpoint, sampleSize }) {
  const barChartData = {
    categories: [],
    bars: [
      {
        name: "Widgets.TotalEmployeesBar.Active",
        data: []
      },
      {
        name: "Widgets.TotalEmployeesBar.Inactive",
        data: []
      },
      {
        name: "Widgets.TotalEmployeesBar.Joined",
        data: []
      }
    ]
  }

  // Order by the most recent year then get the most recent five years
  let dataSet = data.totalEmployeeYears.sort((a, b) => b.year - a.year).slice(0, 5)

  // Now order by year ascending, so the time series goes from left to right
  dataSet = dataSet.sort((a, b) => a.year - b.year)

  dataSet.forEach(year => {
    // Each review name will be a set of results
    barChartData.categories.push(year.year.toString())
    // Results need to be added to same index as category Looping after creation
    // would keep same index
    barChartData.bars.forEach(b => {
      if (b.name === "Widgets.TotalEmployeesBar.Active") b.data.push(year.totalActive)
      else if (b.name === "Widgets.TotalEmployeesBar.Inactive") b.data.push(year.totalInactive)
      else if (b.name === "Widgets.TotalEmployeesBar.Joined") b.data.push(year.totalJoined)
    })
  })

  const titleKey="Widgets.TotalEmployeesBar.Title"
  return (
    <Widget
      columns={2}
      titleKey={titleKey}
      helpKey="Widgets.TotalEmployees.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      sampleSize={sampleSize}
    >
      <ColumnChart
        data={barChartData}
        yAxisTitle="Common.People"
        xAxisTitle="Common.Year"
        chartType="column"
        titleKey={titleKey}
      />
    </Widget>
  )
}

TotalEmployeesBar.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.shape(TotalEmployeesSummaryShape).isRequired,
  exportEndpoint: PropTypes.string.isRequired
}

export default TotalEmployeesBar



// WEBPACK FOOTER //
// ./src/components/widgets/TotalEmployeesBar.jsx